import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import * as angular from 'angular';
import {CarTemplateEditComponent} from "./edit/car-template-edit.component";
import {CarTemplateListComponent} from "./list/car-template-list.component";
import {CarTemplateModerateComponent} from "./moderate/car-template-moderate.component";

/*
* Workaround para que siga funcionando la configuración
* $routeProvider.otherwise() que redirige a la pantalla de error
* cuando se ingresan URLs desconocidas.
* */
angular.module('CarsSaraBo')
    .config(['$routeProvider', ($routeProvider) => {
        $routeProvider.when('/company/:companyId/carTemplate', {template: ''})
            .when('/company/:companyId/carTemplate/picture/:status', {template: ''})
            .when('/company/:companyId/carTemplate/:id', {template: ''})
            .when('/moderateCarTemplate', {template: ''});
    }]);
/***/

const carTemplatesRoutes: Routes = [
    {path: 'moderateCarTemplate', component: CarTemplateModerateComponent},
    {path: 'cars-sara-v2/web/moderateCarTemplate', component: CarTemplateModerateComponent},
    {path: 'company/:companyId/carTemplate', component: CarTemplateListComponent,  pathMatch: 'full'},
    {path: 'cars-sara-v2/web/company/:companyId/carTemplate', component: CarTemplateListComponent,  pathMatch: 'full'},
    {path: 'company/:companyId/carTemplate/picture/:status', component: CarTemplateListComponent},
    {path: 'cars-sara-v2/web/company/:companyId/carTemplate/picture/:status', component: CarTemplateListComponent},
    {path: 'company/:companyId/carTemplate/add', component: CarTemplateEditComponent},
    {path: 'cars-sara-v2/web/company/:companyId/carTemplate/add', component: CarTemplateEditComponent},
    {path: 'company/:companyId/carTemplate/:id', component: CarTemplateEditComponent},
    {path: 'cars-sara-v2/web/company/:companyId/carTemplate/:id', component: CarTemplateEditComponent}
];

@NgModule({
    imports: [
        RouterModule.forChild(carTemplatesRoutes)
    ],
    exports: [
        RouterModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class CarTemplateRoutingModule {
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/carTemplate/car-template-routing.module.ts